import { ServiceFactory } from "../ServiceFactory";

// Export the abstraction, not the implementation
export const refStoresService = ServiceFactory.getRefStoresService();

// Export implementations and types for consumers
export type { IRefStoresService } from "./IRefStoresService";
export { RefStoresService } from "./RefStoresService";
